import { cn } from "@/lib/utils";
import { STATUS_META } from "./kpiFormat";

export const StatusBadge = ({ status, testId, className }) => {
  const meta = STATUS_META[status] || STATUS_META.none;
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-sm border px-1.5 py-0.5 text-2xs font-semibold uppercase tracking-[0.12em]",
        meta.cls,
        className,
      )}
    >
      {meta.label}
    </span>
  );
};
